function recherche_jo(page) {
	document.forms['requete_jo'].page.value=page;
	document.forms['requete_jo'].submit();
}
